import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Creatable from 'react-select/creatable';
import './assets/react-select.css'
import moment from 'moment';
import { connect } from 'react-redux'
import { resetErrors, fetchTransactions, addItem, fetchSaldoFromInicio } from '../actions/transactionsActions'
import { Link, Redirect } from 'react-router-dom'

@connect((store)=>{
  return {
    transactions: store.transactions.transactions,
    error: store.transactions.error,
    fetching: store.transactions.fetching,
    selectedCompany: store.user.selectedCompany,
    currentSettings: store.user.currentSettings,
    saved: store.transactions.saved,
  } 
})
class New extends Component {

  state = {
    data: new Date(),
    tags: null,
    contas: null
  }

  componentWillMount() {
  }

  componentWillUnmount() {
    this.props.dispatch(resetErrors())
    this.props.dispatch(fetchTransactions(this.props.selectedCompany, this.props.currentSettings))
    this.props.dispatch(fetchSaldoFromInicio(this.props.selectedCompany, this.props.currentSettings))
  }
  

  handleSubmit = (e) => {
    e.preventDefault()

    let newData ={
      comprovante:this.comprovante.value,
      conta:this.state.contas.value,
      data: this.state.data,
      debito: this.debito.checked,
      descricao: this.descricao.value,
      processado:this.processado.checked,
      tags: this.state.tags.map(x=>x.value),
      valor: Number(this.valor.value)
    }

      this.props.dispatch(addItem(this.props.selectedCompany, newData))

  }

  handleDate = (selectedOption) => {
    this.setState({data: new Date(selectedOption)})
  }

  handleTags = (selectedOption) => {
    this.setState({tags: selectedOption})
  }

  handleContas = (selectedOption) => {
    this.setState({contas: selectedOption})
  }

  resetErrors = () => {
    this.props.dispatch(resetErrors())
  }


  render() {

    if(this.props.saved){
      return (<Redirect to='/transactions'/>)
    }

    let unique = (arrArg) => {
      return arrArg.filter((elem, pos, arr) => {
        return arr.indexOf(elem) === pos;
      });
    }

    let allTags = this.props.transactions.reduce((int,x)=>{
      int.push(...x.tags)
      return unique(int)
    },[]).map(x=>{
      return {label:x,value:x}
    })

    let allContas = this.props.transactions.reduce((int,x)=>{
      int.push(x.conta)
      return unique(int)
    },[]).map(x=>{
      return {label:x,value:x}
    })

    if(this.props.fetching){
      return (<div className="loader">Loading...</div>)
    }

    if(this.props.saved){
      return (<Redirect to='/transactions'/>)
    }
    
    return (
    <div>
    <h6><i className="far fa-edit" style={{color:"#33C3F0"}}/> Novo Registro</h6>
    <form onSubmit={this.handleSubmit}>
    <div className="row edit-input">
    <label>Data:</label>
    <DatePicker
        inline
        todayButton={"Hoje"}
        required
        selected={moment(this.state.data ? this.state.data : new Date())}
        onChange={this.handleDate}
        dateFormat="LL"
    /></div>
    <div className="row edit-input">
    <label>Valor:</label>
    <input type="number" step="any" required name="valor" ref={(valor) => this.valor = valor}/>
    </div>
    <div className="row edit-input">
    <label>Tags: </label>
    <Creatable
        isMulti
        name="tags"
        value={this.state.tags}
        onChange={this.handleTags}
        options={allTags}
        clearable={true}
        required
      />
    </div>
    <div className="row edit-input">
    <label>Conta: </label>
    <Creatable
        required
        name="contas"
        value={this.state.contas}
        onChange={this.handleContas}
        options={allContas}
        clearable={true}
      />
    </div>
    <div className="row edit-input">
    <label>Comprovante: </label>
    <input type="url" name="comprovante" ref={(comprovante) => this.comprovante = comprovante}/>
    </div>
    <div className="row edit-input">
    <label>Descrição: </label>
    <input type="text" required  name="descricao" ref={(descricao) => this.descricao = descricao} ></input>
    </div>
    <div className="row edit-input">
    <label>Débito: &nbsp;
    <input type="checkbox" 
     name="debito" ref={(debito) => this.debito = debito}/></label>
    <label>Processado: &nbsp;
    <input type="checkbox" 
     name="processado" ref={(processado) => this.processado = processado}/></label>
    </div>
    <div className="row edit-input"><br/>
    <button className="button-primary" type="submit">Adicionar</button>&nbsp;
    <Link to='/transactions'><button className='button'>Cancelar</button></Link>
    </div>
    </form>  
      </div>
    );
  }
}

export default New;



// WEBPACK FOOTER //
// ./src/components/New.js